/**
 * YouTube click-to-play for media panels (.phent-media-youtube in the
 * text-media block): the thumbnail + play button swap for an autoplaying
 * embed on click. Document-delegated so injected/preview markup works.
 */
document.addEventListener('click', (e) => {
    const panel = e.target.closest('.phent-media-youtube');
    if (!panel || panel.dataset.playing) return;

    const id = panel.dataset.videoId;
    if (!id) return;

    panel.dataset.playing = '1';
    panel.innerHTML = `<iframe class="absolute inset-0 w-full h-full" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0" title="YouTube video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
});
